import {
  Box,
  Button,
  FormControl,
  Image,
  Input,
  VStack,
  Flex,
} from "@chakra-ui/react";
import ForgetPassword from "@root/assets/images/forgotpassword.svg";
import { LinkText, StyledInputField } from "@root/commonStyles/commonStyle";
import { ROUTE_NAMES } from "@root/constants";
import { updatePasswordRecoverEmail } from "@root/store/slices/entities";
import { resetPass } from "@root/store/thunks";
import { Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ForgotPasswordForm,
  ForgotPasswordTopHeading,
  ForgotPasswordHeading,
  ForgotPasswordSubHeading,
  FormContainer,
} from "./styles";
import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import { KPSLogoBig } from "@root/assets/icons";

export const ForgotPassword: React.FC = () => {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const initialValues = {
    email: "",
  };
  const redirect_url = `${process.env.REACT_APP_BASE_URL}${ROUTE_NAMES.RESET_PASSWORD}/`;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onSuccess = (email: string) => {
    setLoading(false);
    navigate(ROUTE_NAMES.CHECK_YOUR_EMAIL);
    dispatch(updatePasswordRecoverEmail(email));
  };
  const onSubmitHandler = (values: any) => {
    setLoading(true);
    dispatch(
      resetPass({
        payload: {
          email: values?.email,
          redirect_url,
        },
        onSuccess: () =>
          onSuccess({
            email: values?.email,
            redirect_url,
          } as any),
        onError: () => setLoading(false),
      })
    );
  };
  return (
    <Box>
      <FormContainer>
        <Box mt={"5rem"} mb={"15px"}>
          <KPSLogoBig  />
        </Box>
        <Image src={ForgetPassword} alt="forgetpassword" mt="26px" />
        <ForgotPasswordHeading>
          {t("forgetPassword.forgetPassword")}
        </ForgotPasswordHeading>
        <ForgotPasswordSubHeading>
          {t("forgetPassword.subHeading")}
        </ForgotPasswordSubHeading>
        <Formik initialValues={initialValues} onSubmit={onSubmitHandler}>
          {({ handleSubmit, errors, touched, values, setFieldValue }) => (
            <ForgotPasswordForm
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <VStack mt="28px" spacing={"24px"} align="center">
                <FormControl>
                  <StyledInputField
                    onChange={(e: any) =>
                      setFieldValue("email", e.target.value)
                    }
                    borderColor={values.email ? "purple.500" : "gray.200"}
                    as={Input}
                    id="email"
                    name="email"
                    type="email"
                    required
                    size="full"
                    variant="filled"
                    placeholder={t("login.emailAddress")}
                  />
                </FormControl>
                <Flex alignItems={"center"} gap={"12px"}>
                  <Button
                    type="submit"
                    colorScheme="purple"
                    size="md"
                    fontSize={"16px"}
                    isLoading={loading}
                    rightIcon={<ArrowForwardIcon boxSize="5" color="white" />}
                    background={"purple.purpleGradient"}
                    width={"147px"}
                    borderRadius={"16px"}
                  >
                    {t("forgetPassword.continue")}
                  </Button>
                </Flex>
              </VStack>
            </ForgotPasswordForm>
          )}
        </Formik>
        <LinkText
          my="38px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap="8px"
          to={"/login"}
        >
          <ArrowBackIcon boxSize="20px" color="gray.icon" />
          {t("forgetPassword.backToLogin")}
        </LinkText>
      </FormContainer>
    </Box>
  );
};
